import { capitalize } from '@sorrem-client/ui/shared/text';
import { ESSENCE_ABILITIES, resolveSkillEssenceType, type EssenceAbilityDefinition, type EssenceType } from '@sorrem/shared';

/** One essence type's abilities, as the picker lists them under a heading. */
export interface AbilityPickerGroup {
    readonly essenceType: EssenceType;
    /** The heading, e.g. "Fury". */
    readonly label: string;
    readonly abilities: readonly EssenceAbilityDefinition[];
}

/**
 * Every Essence ability, grouped by the essence type its skill sits under on the
 * tree. Groups and the abilities in them keep their order in `abilities`.
 * Every character holds every Essence skill (at ring 1 or higher), so there
 * is nothing to filter out.
 */
export function toAbilityPickerGroups(abilities: readonly EssenceAbilityDefinition[] = ESSENCE_ABILITIES): AbilityPickerGroup[] {
    const groups = new Map<EssenceType, EssenceAbilityDefinition[]>();
    for (const ability of abilities) {
        const essenceType = resolveSkillEssenceType(ability.skillId);
        if (essenceType === undefined) {
            continue;
        }
        const group = groups.get(essenceType) ?? [];
        group.push(ability);
        groups.set(essenceType, group);
    }
    return [...groups].map(([essenceType, entries]) => ({
        essenceType,
        label: capitalize(essenceType),
        abilities: entries,
    }));
}
